import { useStatsigClient, useExperiment as useStatsigExperiment } from '@statsig/react-bindings';

export enum Experiments {
  INACTIVE_PREPAID_PENDING_SPOTLIGHT_ITEM = 'inactive_prepaid_pending_spotlight',
  INACTIVE_PREPAID_PENDING_WELCOME_MOMENT = 'inactive_prepaid_pending',
  CANCELLED_SPOTLIGHT_ITEM = 'spotlight_card_pendingcancellation',
  SIGNUP_PLAN_SELECTOR_HIGHLIGHTING = 'plan_selector_highlighting',
  // NO_EXPERIMENTS_RUNNING = 'noexperiments_running',
}

export const useExperiment = (key: Experiments) => {
  const { logEvent } = useStatsigClient();
  return { experiment: useStatsigExperiment(key), logEvent };
};
